import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import './InvitedUsers.css';
import { Button, Card, CardContent, Typography } from "@material-ui/core";
import { TextFieldFormsy } from '@fuse';
import Formsy, { addValidationRule } from "formsy-react";
import { GoogleLogin } from 'react-google-login';
import { MicrosoftLogin } from 'react-microsoft-login';
import Config from '../../../config';
import PropTypes from 'prop-types';
import axios from 'axios';
import EndpointsGetter from '../common/EndpointsGetter';
import { connect } from 'react-redux';
import { setUserData } from '../../../store/actions/userActions';

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    card: {
        width: '100%',
        maxWidth: 400,
        margin: '0 auto'
    }
});

addValidationRule('isNotBlankString', (values, value) => {
    return value && value.trim().length > 0;
});

class RegisterInvitedUser extends Component {
    state = {
        canSubmit: false,
        error: ''
    };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    setPassword = (credentials, uid) => {
        let qs = require('qs');
        axios.put(`${EndpointsGetter.getSetNewPasswordEndpoint()}?uid=${uid}`, {
            name: credentials.fullname.trim(),
            password: credentials.password,
            rePassword: credentials.confirmPassword
        })
            .then(response => {
                this.userLogin({
                    email: this.props.email,
                    password: credentials.password,
                });
            })
            .catch(error => {
                this.loginError(error.response);
            });
    }

    googleSuccess = (response) => {
        let updatedResponse = {
            ...response,
            "kanin_uid": this.props.uid
        };
        axios.post(EndpointsGetter.getGoogleLoginEndpoint(), updatedResponse, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA==',
                'Fingerprint': this.props.fingerprint
            }
        })
            .then(response => {
                this.props.setLoginSession(response);
                this.setState({ error: null });
            })
            .catch(error => {
                console.log('Google login error: ', error.response);
                this.loginError(error.response);
            });
    }

    googleFailure = (error) => {
        //TODO handle google oauth integration errors
    }

    microsoftAuthCallback = (error, authData) => {
        if (error) {
            console.log('ms error: ', error);

        } else {
            let updatedData = {
                ...authData,
                "kanin_uid": this.props.uid
            };
            axios.post(EndpointsGetter.getMicrosoftLoginEndpoint(), updatedData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA==',
                    'Fingerprint': this.props.fingerprint
                }
            })
                .then(response => {
                    this.props.setLoginSession(response);
                    this.setState({ error: null });
                })
                .catch(error => {
                    console.log('Microsoft login error: ', error.response);
                    this.loginError(error.response);
                });
        }
    }

    userLogin(credentials) {
        let qs = require('qs');
        axios.post(EndpointsGetter.getAuthEndpoint(), qs.stringify({
            username: credentials.email,
            password: credentials.password,
            client_id: 'spring-security-oauth2-read-write-client',
            grant_type: 'password'
        }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA==',
                    'Fingerprint': this.props.fingerprint
                }
            })
            .then(response => {
                this.props.setLoginSession(response);
                this.setState({ error: null });
            })
            .catch(error => {
                this.loginError(error.response);
            });
    }

    loginError(response) {
        let errorResponse = response.data.error_description || response.data.message;
        this.setState({
            error: errorResponse || 'Something went wrong.'
        });
    }

    render() {
        const { classes, email, uid } = this.props,
            { canSubmit } = this.state;

        return (
            <Card className={classNames(classes.card)}>
                <CardContent className="flex flex-col items-center justify-center p-32">
                    <Typography variant="title" className="card-title">Sign up for your account</Typography>
                    <Formsy
                        onValidSubmit={(model) => this.setPassword(model, uid)}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                        ref={(form) => this.form = form}
                        className="flex flex-col justify-center w-full"
                    >
                        <div style={{ color: 'red', marginBottom: 15 }}>
                            {this.state.error != null ? this.state.error : null}
                        </div>
                        <TextFieldFormsy
                            className="mb-16"
                            type="email"
                            name="email"
                            label="Enter Email"
                            value={email}
                            validations={{
                                minLength: 4,
                                isEmail: true
                            }}
                            validationErrors={{
                                minLength: 'Email cannot be empty',
                                isEmail: 'This is not a valid email'
                            }}
                            required
                            disabled={true}
                        />

                        <TextFieldFormsy
                            className="mb-16"
                            type="text"
                            name="fullname"
                            label="Enter full name"
                            validations={{
                                minLength: 1,
                                maxLength: 50,
                                isNotBlankString: true
                            }}
                            validationErrors={{
                                minLength: 'Name cannot be empty',
                                maxLength: 'Name must not be more than 50 characters',
                                isNotBlankString: 'Name cannot be empty'
                            }}
                            required
                        />

                        <TextFieldFormsy
                            className="mb-16"
                            type="password"
                            name="password"
                            label="Create password"
                            validations={{
                                minLength: 4
                            }}
                            validationErrors={{
                                minLength: 'Password must be atleast 4 characters'
                            }}
                            required
                        />

                        <TextFieldFormsy
                            className="mb-16"
                            type="password"
                            name="confirmPassword"
                            label="Confirm password"
                            validations={{
                                minLength: 4,
                                equalsField: "password"
                            }}
                            validationErrors={{
                                minLength: 'Password must be atleast 4 characters',
                                equalsField: 'Passwords do not match'
                            }}
                            required
                        />

                        <Button
                            type="submit"
                            variant="raised"
                            color="primary"
                            className="w-full mx-auto mt-16 normal-case"
                            aria-label="SIGN UP"
                            disabled={!canSubmit}
                            value="legacy"
                        >
                            Sign up
                        </Button>
                    </Formsy>
                    <span className='or-separator'>
                        OR
                    </span>
                    <GoogleLogin
                        clientId={Config.googleClientId}
                        buttonText="Sign in with Google"
                        onSuccess={this.googleSuccess}
                        onFailure={this.googleFailure}
                        theme='light'
                        className='third-party-sign-in-btn my-24'
                    />
                    <MicrosoftLogin
                        clientId={Config.msClientId}
                        authCallback={this.microsoftAuthCallback}
                        buttonTheme='dark'
                        withUserData={true}
                        debug={true}
                        className='third-party-sign-in-btn'
                    />
                    <div className='already-existing'>
                        <a href='/login'>Already have a Kanin account? Log in</a>
                    </div>
                </CardContent>
            </Card>
        )
    }
}

RegisterInvitedUser.propTypes = {
    fingerprint: PropTypes.string,
    email: PropTypes.string,
    uid: PropTypes.string,
    setLoginSession: PropTypes.func
};

const mapDispatchToProps = {
    setUserData
};

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, mapDispatchToProps)(RegisterInvitedUser)));


// WEBPACK FOOTER //
// ./src/main/content/invited-users/RegisterInvitedUser.js